import { deleteRequest, get, post, postfd, put } from "../helpers/apihelpers";

export const CreateOpinionFileAttachmentService=async(data)=>{
    try {
        const result = await post(`api/opinion_file_attachment/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateOpinionFileAttachmentService=async(data,id)=>{
    try {
        const result = await post(`api/opinion_file_attachment/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetOpinionFileAttachmentService=async(id)=>{
    try {
        const result = await get(`api/opinion_file_attachment/get/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}



export const DeleteOpinionFileAttachmentService=async(id)=>{
    try {
        const result = await deleteRequest(`api/opinion_file_attachment/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

